import React from 'react'
import { useSelector } from 'react-redux'

import { getCampaignToSchedule } from 'Redux/selectors/campaigns'

import { TrackInfoProps } from './props'
import { TrackInfoContainer, Avatar, TextInfo, Title, Author } from './styles'

export const TrackInfo: React.FC<TrackInfoProps> = () => {
  const campaignDetails = useSelector(getCampaignToSchedule)

  return (
    <TrackInfoContainer>
      <Avatar src={campaignDetails?.track?.cover} alt="track_avatar" />
      <TextInfo>
        <Title>{campaignDetails?.track?.title}</Title>
        <Author>{campaignDetails?.track?.author}</Author>
      </TextInfo>
    </TrackInfoContainer>
  )
}
